import { render, staticRenderFns } from "./PrestazioniSanitarie.vue?vue&type=template&id=0b14d2cf&"
import script from "./PrestazioniSanitarie.vue?vue&type=script&lang=js&"
export * from "./PrestazioniSanitarie.vue?vue&type=script&lang=js&"
import style0 from "./PrestazioniSanitarie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports